import { Atom } from 'AppReact';
import styled, { css } from "styled-components";


const template = styled.div`
  ${({ theme, displayState }) => css`
    color: ${theme?.colour?.secondary ?? "#04333B"};
    font-size: ${displayState?.mobileSmall ? '12px' : '16px'};
    text-decoration: underline;
    margin-left: 7px;
    white-space: nowrap;
    
    cursor: pointer;

    &:active {
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    &:hover {
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    }

    ${displayState?.selected && css`
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    `}

    ${displayState.disabled && css`
      cursor: not-allowed;
      color: ${theme?.colour?.secondary ?? "#04333B"};
      opacity: .4;
    `}

    @media only screen and (min-width: 768px) {
      font-size: 12px;
    }
  `}
`;


export default Atom({ type: 'button', dataType: 'string', template })